module.exports = __webpack_public_path__ + "static/media/right_icon.e1573afe.svg";